/**
 * Skip-to-content link. Visually hidden until keyboard-focused.
 * Renders as the first focusable element in <body> so Tab from URL bar lands here.
 */

export default function SkipToContent({ targetId = 'main' }: { targetId?: string }) {
  return (
    <a
      href={`#${targetId}`}
      className="
        sr-only focus:not-sr-only
        focus:fixed focus:top-3 focus:left-3 focus:z-[100]
        focus:rounded-xl focus:bg-primary-500 focus:px-4 focus:py-2.5
        focus:text-sm focus:font-semibold focus:text-white
        focus:shadow-lg focus:outline-none
        focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2
      "
    >
      Pular para o conteúdo
    </a>
  );
}
